export default __webpack_public_path__ + "static/media/Savant's Wrists of the Crescent.787ed140.jpg";